import { initLucideIcons, refreshLucideIconsScoped } from './lucide';

document.addEventListener('lucide:refresh', (event) => {
  const root = event?.detail?.root;
  if (root) {
    refreshLucideIconsScoped(root);
  } else {
    initLucideIcons();
  }
});
